import { render, staticRenderFns } from "./Pftd.vue?vue&type=template&id=78bda628&scoped=true"
import script from "./Pftd.vue?vue&type=script&lang=js"
export * from "./Pftd.vue?vue&type=script&lang=js"
import style0 from "./Pftd.vue?vue&type=style&index=0&id=78bda628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78bda628",
  null
  
)

export default component.exports